/**
 * An optimized H1 component.
 *
 * @param props
 * @returns h1
 */
export const H1: React.FC<JSX.IntrinsicElements["h1"]> = (props) => {
  return (
    <h1
      {...props}
      className={`text-[32px] leading-[44px] font-circular ${props.className}`}
    >
      {props.children}
    </h1>
  )
}
